<template>
  <div class="home">
    <div class="banner">
      <img class="bannerBg" src="https://image.ceekee.com/h5/banner.png" />
      <div class="fontImg">
        <p>一站式解决企业差旅需求</p>
        <p class="banner-title-bottom">
          助力企业 <span>节省25%</span> 差旅成本
        </p>
      </div>
      <img
        class="bannerIcon"
        src="@/assets/images/footLogo.png"
        alt=""
        srcset=""
      />
      <router-link class="linkImg" to="/apply">
        <img src="https://image.ceekee.com/h5/组 -3.png" />
      </router-link>
    </div>
    <a class="bannerPhone" href='tel:18835730716'>
      <img src="https://image.ceekee.com/h5/组 214.png" alt="" srcset="" />
      <div class="bannerPhone-cont">
        <p>现在咨询（188-3573-0716）</p>
        <p>免费赠送 企业差旅管理执行方案一份</p>
      </div>
    </a>
    <!-- 第一部分 -->
    <div class="section one">
      <div class="content">
        <div class="sec-title">
          <span>一站式采购+企业支付+费控为核心</span>
          <i>帮助企业提升差旅管理、控制费用支出</i>
        </div>
      </div>
      <div class="one-item">
        <div>一站式采购 +企业支付</div>
        <p>10大场景，覆盖企业差旅及其它增值服务全场景</p>
      </div>
      <div class="one-item">
        <div>费用管控</div>
        <p>10大场景，赋能企业费用管控全闭环</p>
      </div>
    </div>

    <!-- 第二部分 -->
    <div class="section two">
      <div class="content">
        <div class="sec-title">
          <span>直击企业差旅痛点</span>
          <i>提升各类角色的满意度</i>
        </div>
      </div>
      <div class="two-item">
        <div class="tow-item-cont">
          <h3>管理者</h3>
          <p>
            <span>节省差旅成本</span><span>提升差旅效率</span
            ><span>员工满意度提升</span>
          </p>
        </div>
        <img src="https://image.ceekee.com/h5/滚动组 2.png" alt="" />
      </div>
      <div class="two-item">
        <div class="tow-item-cont">
          <h3>财务</h3>
          <p><span>数据合规透明</span><span>避免大量发票审核</span></p>
        </div>
        <img src="https://image.ceekee.com/h5/滚动组 3.png" alt="" />
      </div>
      <div class="two-item">
        <div class="tow-item-cont">
          <h3>行政</h3>
          <p><span>减轻工作压力</span><span>无需多方比价</span></p>
        </div>
        <img src="https://image.ceekee.com/h5/滚动组 4.png" alt="" />
      </div>
      <div class="two-item">
        <div class="tow-item-cont">
          <h3>员工</h3>
          <p><span>免垫资、免报销</span><span>一站式预订</span></p>
        </div>
        <img src="https://image.ceekee.com/h5/滚动组 5.png" alt="" />
      </div>
    </div>

    <!-- 第三部分 -->
    <div class="section three">
      <div class="sec-title">
        <span>全新的企业差旅管理流程</span>
        <i>告别传统/低效的企业差旅</i>
      </div>
      <div class="three-item">
        <div class="three-item-cont">
          <div class="three-item-cont-top">
            <h3>事前管控</h3>
            <span></span>
          </div>
          <div class="three-item-cont-bottom">
            <p><span>组织管理</span><span>差标配置</span></p>
            <p><span>审批配置</span><span>预算管理</span></p>
          </div>
        </div>
        <img src="https://image.ceekee.com/h5/蒙版组 33.png" alt="" srcset="" />
      </div>
      <div class="three-item">
        <div class="three-item-cont">
          <div class="three-item-cont-top">
            <h3>消费支付</h3>
            <span></span>
          </div>
          <div class="three-item-cont-bottom">
            <p><span>企业支付</span><span>实时订单详情</span></p>
            <p><span>费用归属</span><span>消息通知</span></p>
          </div>
        </div>
        <img src="https://image.ceekee.com/h5/蒙版组 32.png" alt="" srcset="" />
      </div>
      <div class="three-item">
        <div class="three-item-cont">
          <div class="three-item-cont-top">
            <h3>统一结算</h3>
            <span></span>
          </div>
          <div class="three-item-cont-bottom">
            <p><span>标准账单</span></p>
            <p><span>统一发票</span></p>
          </div>
        </div>
        <img src="https://image.ceekee.com/h5/蒙版组 31.png" alt="" srcset="" />
      </div>
      <div class="three-item">
        <div class="three-item-cont">
          <div class="three-item-cont-top">
            <h3>财务入账</h3>
            <span></span>
          </div>
          <div class="three-item-cont-bottom">
            <p><span>映射财务科目</span></p>
            <p><span>生成财务数据</span><span>财务一次入账</span></p>
          </div>
        </div>
        <img src="https://image.ceekee.com/h5/蒙版组 30.png" alt="" srcset="" />
      </div>
      <div class="three-item">
        <div class="three-item-cont">
          <div class="three-item-cont-top">
            <h3>数据分析</h3>
            <span></span>
          </div>
          <div class="three-item-cont-bottom">
            <p><span>产品线消费分析</span></p>
            <p><span>部门/项目消费分析</span><span>节省分析</span>浪费分析</p>
          </div>
        </div>
        <img src="https://image.ceekee.com/h5/蒙版组 29.png" alt="" srcset="" />
      </div>
      <router-link to="/apply">
        <img class="appointment" src="https://image.ceekee.com/h5/组 -3.png" />
      </router-link>
    </div>

    <!-- 第四部分 -->
    <div class="section four">
      <div class="content">
        <div class="sec-title">
          <span>6大管家式服务</span>
          <i>站在企业角度解决所有差旅问题</i>
        </div>
      </div>
      <div class="four-item">
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 215.png" alt="" />
          <div>
            <h3>一站式采购</h3>
            <p>差旅出行消费一站解决</p>
            <p>杜绝跨平台消费的困扰</p>
          </div>
        </div>
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 216.png" alt="" />
          <div>
            <h3>严选服务</h3>
            <p>海量供应商严选资源</p>
            <p>总能找到您想要的低价</p>
          </div>
        </div>
      </div>
      <div class="four-item">
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 217.png" alt="" />
          <div>
            <h3>统一结算</h3>
            <p>月结垫资服务</p>
            <p>避免反复请款，不占用</p>
            <p>企业资金流</p>
          </div>
        </div>
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 218.png" alt="" />
          <div>
            <h3>数据分析</h3>
            <p>部门/项目/节省/浪费等27个</p>
            <p>纬度的数据分析，专业差旅建议</p>
          </div>
        </div>
      </div>
      <div class="four-item">
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 219.png" alt="" />
          <div>
            <h3>专属VIP</h3>
            <p>7*24小时在线服务</p>
            <p>2对1微信群处理，高速响应</p>
          </div>
        </div>
        <div class="four-item-box">
          <img src="https://image.ceekee.com/h5/组 220.png" alt="" />
          <div>
            <h3>协议托管</h3>
            <p>支持及酒店集团、</p>
            <p>各大航司的协议托管</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 第五部分 -->
    <div class="section five">
      <div class="content">
        <div class="sec-title">
          <span>数千家企业选择差旅管家Tripwise</span>
          <i>覆盖医疗、制造、金融、教育、消费零售、互联网等众多行业</i>
        </div>

        <div class="sectionFive">
          <div><img src="https://image.ceekee.com/h5/蒙版组 14.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 95.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 96.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 100.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 97.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 98.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 99.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 93.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 104.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 103.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 102.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 105.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 101.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 87.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 92.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 91.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 88.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 85.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 89.png" /></div>
          <div><img src="https://image.ceekee.com/h5/组 90.png" /></div>
        </div>
      </div>
    </div>

    <!-- 底部 -->
    <div class="footer">
      <div class="footer-info">
        <div class="footer-info-top">
          <img src="https://image.ceekee.com/h5/位图.png" alt="">
          <div class="footer-info-top-rt">
            <img src="https://image.ceekee.com/h5/组 221.png" alt="">
            <img src="https://image.ceekee.com/h5/组 222.png" alt="">
          </div>
        </div>
        <div class="footer-info-bottom">
          <p>咨询电话：400-900-5788</p>
          <p>联系方式：魏女士 188-3573-0716（同微信）</p>
        </div>
      </div>
      <div class="footer-copy">Copyright 2016-2020 苏州思客信息技术有限公司ICP备案：苏ICP备</div>
    </div>
    <div class="fixed-phone">
      <a href='tel:18835730716'><img src="https://image.ceekee.com/h5/滚动组 6.png" alt="" srcset=""> <p>拨打电话</p></a>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    // Partner,
  },
};
</script>

<style scoped lang="less">
@import url("./home.less");
</style>